var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4999 2.5V4.16667",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 2.5V4.16667",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.49967H15.8333",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 8.33301V5.83301C15.8333 4.45217 14.7142 3.33301 13.3333 3.33301H5C3.61917 3.33301 2.5 4.45217 2.5 5.83301V13.333C2.5 14.7138 3.61917 15.833 5 15.833H8.33333",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4941 13.3193V14.7843L15.6458 15.4868",
    stroke: "#8A94A6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 18.333C12.5124 18.333 10.8333 16.6547 10.8333 14.583C10.8333 12.5547 12.5583 10.8305 14.5866 10.833C16.6566 10.8347 18.3333 12.513 18.3333 14.583C18.3333 16.6538 16.6549 18.333 14.5833 18.333",
    stroke: "#8A94A6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendericon);
export default __webpack_public_path__ + "static/media/calendericon.7d1f146f537f6cc943a6ec1a132a033a.svg";
export { ForwardRef as ReactComponent };